import { render, staticRenderFns } from "./GrantsConstraintsPlansNameTable.vue?vue&type=template&id=2f5a0a59&"
import script from "./GrantsConstraintsPlansNameTable.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports